import { rest } from 'lodash';
import { getWorkout } from './getWorkout';

export const setWorkoutIds = (curRoutine: IChallengeRoutines) => {
console.log(curRoutine.workout_id, curRoutine.workout_ids_array);
  let workoutIds = [];

  if (curRoutine.workout_id) {
    workoutIds.push(curRoutine.workout_id);
  }

  if (curRoutine.workout_ids_array) {
  if (curRoutine.workout_ids_array.length > 0) {
    workoutIds = [
      ...curRoutine.workout_ids_array.map((v) => v.id?v.id:v as unknown as number),
    ];
  }
}
console.log(workoutIds);

  return workoutIds;
};

const setAltWorkoutsPart = (
  workouts: Workout[],
  workoutIds: number[],
  curRoutine: IChallengeRoutines,
) => {
  let altWorkoutsPart = null;
  const mainWorkout = getWorkout(workouts, workoutIds[0]);

  if (mainWorkout) {
    altWorkoutsPart = mainWorkout.part.id;
  }

  if (curRoutine.alt_workouts_part) {
    altWorkoutsPart = curRoutine.alt_workouts_part;
  }

  if (curRoutine.alt_workouts_part_id) {
    altWorkoutsPart = curRoutine.alt_workouts_part_id;
  }

  return altWorkoutsPart;
};

export const setServerRoutine = (
  curRoutine: IChallengeRoutines,
  workouts: Workout[],
) => {
  const workoutIds = setWorkoutIds(curRoutine);
  const altWorkoutsPart = setAltWorkoutsPart(workouts, workoutIds, curRoutine);

  return {
    ...curRoutine,
    id: curRoutine.id,
    // name: curRoutine.name,
    // part: curRoutine.part,
    date: curRoutine.date,
    weight_multiplier: +curRoutine.weight_multiplier,
    body_weight_multiplier: +curRoutine.body_weight_multiplier,
    weight_kg: +curRoutine.weight_kg,
    weight_lbs: +curRoutine.weight_lbs,
    count_placeholder: curRoutine.count_placeholder,
    rir: curRoutine.rir === '' ? null : curRoutine.rir,
    weight_placeholder: curRoutine.weight_placeholder,
    count: +curRoutine.count,
    set_count: +curRoutine.set_count,
    condition_id: curRoutine.challenge_condition?.id || null,
    alt_workouts_part_id: altWorkoutsPart,
    workout_ids: workoutIds,
    tip: curRoutine.tip,
    rest_time_sec:
      curRoutine.rest_time_sec === '' ? null : curRoutine.rest_time_sec,
  };
};

export const setNewRoutine = (
  curRoutine: IChallengeRoutines,
  workouts: Workout[],
) => {
  const workoutIds = setWorkoutIds(curRoutine);
  const altWorkoutsPart = setAltWorkoutsPart(workouts, workoutIds, curRoutine);

  return {
    ...curRoutine,
    id: undefined,
    workout_ids: workoutIds,
    // name: item.name,
    // part: item.part,
    date: curRoutine.date,
    rir: curRoutine.rir === '' ? null : curRoutine.rir,
    weight_multiplier: +curRoutine.weight_multiplier,
    count_placeholder: curRoutine.count_placeholder,
    weight_placeholder: curRoutine.weight_placeholder,
    body_weight_multiplier: +curRoutine.body_weight_multiplier,
    weight_kg: +curRoutine.weight_kg,
    weight_lbs: +curRoutine.weight_lbs,
    count: +curRoutine.count,
    set_count: +curRoutine.set_count,
    condition_id: curRoutine.challenge_condition?.id || null,
    alt_workouts_part_id: altWorkoutsPart,
    tip: curRoutine.tip,
    rest_time_sec:
      curRoutine.rest_time_sec === '' ? null : curRoutine.rest_time_sec,
  };
};

export const setServerToLocalRoutine = (
  curRoutine: IChallengeRoutines,
  workouts: Workout[],
) => {
  let firstWorkout: Workout | null = null;
  const workoutsArray: Workout[] = [];
  if (curRoutine.alt_workouts && curRoutine.alt_workouts.length > 0) {
    const { alt_workouts } = curRoutine;
    const firstAltWorkout = alt_workouts[0];
    firstWorkout = {
      id: 0,
      name: firstAltWorkout.name || '',
      display_order: null,
      part: {
        id: 0,
        name: curRoutine.part || '',
        display_order: null,
      },
    };
  }
  if (curRoutine.workout_id) {
    firstWorkout = {
      id: curRoutine.workout_id,
      name: curRoutine.name || '',
      display_order: null,
      part: {
        id: 0,
        name: curRoutine.part || '',
        display_order: null,
      },
    };
  }
  console.log(curRoutine.alt_workouts,'fuck')
  return {
    ...curRoutine,
    id: curRoutine.id,
    workout_id: firstWorkout?.id || null,
    name: firstWorkout?.name || '',
    part: firstWorkout?.part?.name || '',
    date: curRoutine.date,
    rir: curRoutine.rir === '' ? null : curRoutine.rir,
    weight_multiplier: +curRoutine.weight_multiplier,
    count_placeholder: curRoutine.count_placeholder,
    weight_placeholder: curRoutine.weight_placeholder,
    body_weight_multiplier: +curRoutine.body_weight_multiplier,
    weight_kg: curRoutine.weight_kg,
    weight_lbs: curRoutine.weight_lbs,
    count: +curRoutine.count,
    set_count: +curRoutine.set_count,
    condition_id: curRoutine.challenge_condition?.id || null,
    challenge_condition: curRoutine.challenge_condition,
    tip: curRoutine.tip,
    alt_workouts_part: curRoutine.alt_workouts_part,
    workout_ids_array: curRoutine.alt_workouts,
    workout_ids: curRoutine.alt_workouts,
    rest_time_sec:
      curRoutine.rest_time_sec === null ? null : +curRoutine.rest_time_sec,
  };
};
